export default __webpack_public_path__ + "images/5M.27b6cba.png";